import { all, fork } from 'redux-saga/effects'
import getStoriesSaga from './getStoriesSaga'

export default function* storiesSaga() {
  yield all([fork(getStoriesSaga)])
}
